import styled from 'styled-components';
import { EGerdauHomeCard } from '../../components/EGerdauHome/styles';
import { Check } from '@styled-icons/boxicons-regular/Check';
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline';

export const FormCard = styled(EGerdauHomeCard)`
  & > #first-login-form {
    & > .ant-form-item:not(:first-child) {
      margin-top: 1rem;
    }

    & .userAcceptNotification {
      font-size: 0.675rem;
    }

    & > .actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 1rem;
    }
  }
`;

export const PasswordRules = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0.5rem 0.5rem 0;

  & > header {
    & > .title {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
    }

    & > .sub-title {
      font-size: 0.875rem;
    }
  }

  & > .content {
    font-size: 0.875rem;
    margin-left: 1.5rem;

    & > span {
      font-weight: 600;
    }
  }
`;

export const CheckIcon = styled(Check)`
  color: ${({ theme }) => theme.colors.green};
  width: 1rem;
`;

export const CloseIcon = styled(CloseOutline)`
  color: ${({ theme }) => theme.colors.red};
  width: 1rem;
`;
